<template>
  <div class="d-flex flex-column"  :class="{ 'mb-2': !hasResultsSlot }">
    <div class="px-2 d-flex align-center">
      <v-text-field
        rounded solo dense
        color="grey"
        background-color="white"
        :value="value"
        @input="onInput"
        label="Search"
        hide-details="auto"
        prepend-inner-icon="mdi-magnify"
      >
      </v-text-field>
      <slot name="extra_buttons">
      </slot>
    </div>
    <div v-if="hasResultsSlot" class="py-1">
      <slot name="results" />
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchBar",

  props: ['value'],

  computed: {
    hasResultsSlot () {
      return !!this.$slots.results
    },
  },

  methods: {
    onInput(newVal) {
      this.$emit('input', newVal)
    },
  }
}
</script>